import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { FadeView, LoadingDots, useResponsive } from '@garnish/core';
import { GlassView } from '@garnish/glass';

// ─────────────────────────────────────────────────────────────────────────────

export const OrderAgainInfiniteLoadingIndicator = (
  props: OrderAgainInfiniteLoadingIndicatorProps,
) => {
  const { isVisible, isLiquidGlassEnabled = false } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.container, match([styles.containerXS, styles.containerSM])];
  const iconContainerStyles = [
    styles.iconContainer,
    isLiquidGlassEnabled ? styles.iconContainerGlass : styles.iconContainerSolid,
  ];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <FadeView show={isVisible} style={containerStyles}>
      <View style={iconContainerStyles}>
        {isLiquidGlassEnabled ? <GlassView glassEffectStyle="clear" style={styles.glass} /> : null}

        <LoadingDots color={theme.colors.WHITE} />
      </View>
    </FadeView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const ICON_CONTAINER_SIZE = 40;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
  },
  containerXS: {
    marginBottom: theme.spacing['10'],
    marginLeft: theme.spacing['4'],
  },
  containerSM: {
    marginBottom: theme.spacing['8'],
    marginLeft: theme.spacing['6'],
  },
  iconContainer: {
    width: ICON_CONTAINER_SIZE,
    height: ICON_CONTAINER_SIZE,
    borderRadius: ICON_CONTAINER_SIZE,
  },
  iconContainerSolid: {
    backgroundColor: theme.colors.KALE,
    ...theme.elevations['2'],
  },
  iconContainerGlass: {
    backgroundColor: 'rgba(0, 71, 60, 0.95)',
  },
  glass: {
    ...StyleSheet.absoluteFill,
    borderRadius: ICON_CONTAINER_SIZE,
    pointerEvents: 'none',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderAgainInfiniteLoadingIndicatorProps = {
  isVisible: boolean;
  isLiquidGlassEnabled?: boolean;
};
